import * as React from "react";
import Collapsible from "react-collapsible";

// Components
import MoreInfoTrigger from "../MoreInfoTrigger/MoreInfoTrigger";
import MoreInfoContent from "../MoreInfoContent/MoreInfoContent";

// Styles
import "../InputRadio/InputRadio.scss";

interface AutoFillOption {
  id: string;
  label: string;
  value: string;
  infoText: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => any;
}

const AutoFillOption: React.FC<AutoFillOption> = (props: AutoFillOption) => {
  const { id, label, value, infoText, onChange } = props;
  const [isToggleOpen, setIsToggleOpen] = React.useState(false);

  return (
    <div className="input-radio">
      <div className="mb-2 relative">
        <input
          name="default"
          id={`options_${id}`}
          type="radio"
          value={id}
          checked={value === id}
          onChange={onChange}
        />
        <label htmlFor={`options_${id}`}>
          <span>{label}</span>
        </label>
      </div>
      <div className="fix-top-margin">
        <Collapsible
          open={isToggleOpen}
          handleTriggerClick={() => setIsToggleOpen(!isToggleOpen)}
          trigger={<MoreInfoTrigger />}
          easing="cubic-bezier(0.5, 1, 0.89, 1)"
        >
          <MoreInfoContent
            text={infoText}
            closeFunc={() => setIsToggleOpen(false)}
          />
        </Collapsible>
      </div>
    </div>
  );
};

export default AutoFillOption;
